define([], () => {
    return ['$http', 'LocaleService', 'configBasler', 'ContextService', 'MagnoliaService',
        function ($http, LocaleService, configBasler, ContextService, MagnoliaService) {
            const BALOISEDIRECT_CHANNEL = 'baloisedirectmotorfahrzeug';

            return {
                getInfoText,
                getUWIssueText: key => retrieveText(MagnoliaService.getUWIssueText, key),
                getSlogan: key => retrieveText(MagnoliaService.getSlogan, key),
            };

            function getInfoText(key) {
                const MOTORCYCLEKEY = `${key}_MC`;
                const PERSONCARKEY = key;

                if (ContextService.isMotorcycleMode()) {
                    return retrieveText(MagnoliaService.getInfoText, MOTORCYCLEKEY)
                        .catch(() => retrieveText(MagnoliaService.getInfoText, PERSONCARKEY));
                }

                return retrieveText(MagnoliaService.getInfoText, PERSONCARKEY);
            }

            function retrieveText(magnoliaFunction, key) {
                const product = ContextService.getProductCode();

                if (product && product.toLowerCase() !== BALOISEDIRECT_CHANNEL) {
                    return magnoliaFunction(product, key)
                        .catch(() => magnoliaFunction(BALOISEDIRECT_CHANNEL, key));
                }

                return magnoliaFunction(BALOISEDIRECT_CHANNEL, key);
            }
        },
    ];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/services/TextRetrievalService.js